import { render, staticRenderFns } from "./DocToSlideImportModal.vue?vue&type=template&id=5321e47e&scoped=true&"
import script from "./DocToSlideImportModal.vue?vue&type=script&lang=js&"
export * from "./DocToSlideImportModal.vue?vue&type=script&lang=js&"
import style0 from "./DocToSlideImportModal.vue?vue&type=style&index=0&id=5321e47e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5321e47e",
  null
  
)

export default component.exports